import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="min-h-screen flex items-center justify-center bg-cream pt-20">
      <div className="text-center px-6">
        <div className="font-display text-clay-500 text-[10rem] leading-none">
          404
        </div>
        <h1 className="mt-4 font-display text-4xl text-forest-900">
          This page does not exist.
        </h1>
        <p className="mt-4 text-forest-900/70 max-w-md mx-auto">
          The trail you followed may have grown over. Head back to the river.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-forest-700 text-cream hover:bg-forest-900 transition-colors"
        >
          Back home
        </Link>
      </div>
    </section>
  );
}
